import React from 'react';

export default function Spinner({ size = 16, className = '' }) {
  return (
    <span
      className={`inline-block animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
      style={{ width: size, height: size, lineHeight: 0 }}
      role="status"
      aria-label="Cargando"
    />
  );
}

export function LoadingScreen({ label = 'Cargando...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3 text-ink-3">
      <Spinner size={32} className="text-purple" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
